import React, { useEffect, useState } from "react";
import SiteCardWithDetail from "../site-card-with-detail";
import { useTranslation } from "react-i18next";

function SiteBoxDetailType2(props) {
  const [listSite, setListSite] = useState([]);
  const { t } = useTranslation("settings");

  useEffect(() => {
    if (Array.isArray(props.listSite)) {
      let listX = props.listSite;
      listX = listX.filter((x) => x.Visible);
      setListSite(listX);
    }
  }, [props.listSite]);

  function onToggleActiveSite(param) {
    try {
      props.onChangeActiveSite(param);
    } catch {}
  }

  return (
    <div className="w-full h-full bg-white rounded-lg shadow-content-box">
      <div className="h-[48px] mx-2 mb-2.5  border-b border-solid border-quartenary flex items-center">
        <p className="text-base font-bold text-black">
          {t("site_management.site_detail")}
        </p>
      </div>
      <div className="overflow-y-auto h-[calc(100%-68px)] pr-1 ml-2 mr-1">
        {listSite.map((value, index) => {
          return (
            <SiteCardWithDetail
              key={value.Id}
              detailSite={value}
              onToggle={(e) => {
                onToggleActiveSite(e);
              }}
            />
          );
        })}
      </div>
    </div>
  );
}

export default SiteBoxDetailType2;
